import { useState } from 'react';
import { heroStats } from '@/mocks/home';

export default function Hero() {
  const [keyword, setKeyword] = useState('');

  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200/70">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-background-100 to-background-50" />
      <div className="relative mx-auto grid w-full max-w-shell grid-cols-1 items-center gap-12 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2 lg:gap-16">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5">
            <span className="flex h-4 w-4 items-center justify-center text-accent-600">
              <i className="ri-sparkling-2-line text-sm" />
            </span>
            <span className="font-label text-[12px] tracking-wide text-foreground-700">
              资源聚合 · 分类索引 · 一站导航
            </span>
          </div>

          <h2 className="mt-6 font-heading text-[2.25rem] font-black leading-[1.15] tracking-tight text-foreground-950 md:text-[3.25rem]">
            黑料总站
            <span className="mt-3 block font-heading text-xl font-semibold text-foreground-700 md:text-2xl">
              资源 · 合集 · 分类，一处直达
            </span>
          </h2>

          <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            黑料总站资源、合集、大全、汇总与分类信息集中展示，聚合各类内容索引。
            无需逐站翻找，按分类即可快速浏览，节省查找时间，一站获取完整资源导航。
          </p>

          <div className="mt-8 flex w-full max-w-lg items-center gap-2 rounded-lg border border-background-200 bg-background-50 p-1.5">
            <span className="flex h-10 w-10 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-lg" />
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入关键词，检索分类与合集"
              className="h-10 min-w-0 flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <a
              href="#categories"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-[13px] text-background-50 transition-colors hover:bg-primary-600"
            >
              检索
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#categories"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 font-label text-[13px] text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-layout-grid-line" />
              浏览全量分类
            </a>
            <a
              href="#ranking"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-[13px] text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-bar-chart-2-line" />
              查看热度榜
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {stat.value}
                </dt>
                <dd className="mt-1 font-label text-[11px] leading-snug text-foreground-500 md:text-xs">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up delay-2">
          <div className="relative w-full">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20abstract%20editorial%20composition%20of%20floating%20paper%20index%20cards%20and%20neatly%20stacked%20archive%20boxes%20in%20warm%20ivory%20and%20deep%20clay%20tones%2C%20dramatic%20soft%20sidelight%2C%20layered%20geometric%20depth%2C%20generous%20negative%20space%2C%20minimalist%20refined%20aesthetic%2C%20clean%20warm%20beige%20background%2C%20subtle%20paper%20texture%2C%20high%20detail%2C%20harmonious%20neutral%20palette&width=900&height=1100&seq=blackliao-hero-01&orientation=portrait"
                alt="黑料总站资源与分类索引示意图"
                title="黑料总站资源与分类索引"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute bottom-4 left-4 right-4 rounded-lg border border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur-sm">
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-label text-[11px] text-foreground-500">今日新增索引</p>
                  <p className="mt-0.5 font-heading text-lg font-bold text-foreground-950">
                    42 条
                  </p>
                </div>
                <div className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5">
                  <i className="ri-flashlight-line text-accent-700" />
                  <span className="font-label text-[11px] text-accent-900">实时汇总中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}